export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Common.json?hash=aada34a5ce8ccfc0335d6af9c1523039";